$(function() {
    const targets = document.querySelectorAll('.MS__popup');
    if (!targets.length) return;

    const prevClassMap = new Map();

    // Helper function để xử lý class thay đổi
    const handleActiveChange = (target, isActive) => {
        const msOuter = target.closest('.MS__outer');
        const layerPopup = document.querySelector('.layer__popup');

        if (isActive) {
            if (layerPopup) {
                layerPopup.classList.add('active');
            }
            if (msOuter) {
                msOuter.classList.add('activepopup');
            }
        } else {
            if (layerPopup) {
                layerPopup.classList.remove('active');
            }
            if (msOuter) {
                msOuter.classList.remove('activepopup');
            }
        }
    };

    // Lưu trữ class ban đầu của mỗi element
    targets.forEach(target => {
        prevClassMap.set(target, target.className);

        // Track ngay lúc load: nếu đã có class active
        if (target.className.includes('active')) {
            handleActiveChange(target, true);
        }
    });

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName !== 'class') return;

            const target = mutation.target;
            const prevClass = prevClassMap.get(target) || '';
            const currentClass = target.className;

            const wasActive = prevClass.includes('active');
            const isActive = currentClass.includes('active');

            if (wasActive !== isActive) {
                handleActiveChange(target, isActive);
            }

            prevClassMap.set(target, currentClass);
        });
    });

    // Theo dõi tất cả các elements
    targets.forEach(target => {
        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
});